var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoft2Lengeh1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59 30",
    style: {
      enableBackground: "new 0 0 59 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.3,15.2h-9.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h9.7c0.3,0,0.5,0.2,0.5,0.5S51.6,15.2,51.3,15.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.3,19.6 42.3,9.8 37.4,14.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4,20.2c-0.3,0-0.5-0.2-0.5-0.5V9.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v9.9C15.9,20,15.7,20.2,15.4,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4,15.3h-9.9c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h9.9c0.3,0,0.5,0.2,0.5,0.5S20.6,15.3,20.4,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,30H0V0h59V30z M1,29h57V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,26H33.3V3.7H55V26z M34.3,25h19.8V4.7H34.3V25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2,30h-30V0h30V30z M1.2,29h28.1V1H1.2V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7,3.9H0.9c-0.3,0-0.5-0.2-0.5-0.5S0.7,3,0.9,3h28.8c0.3,0,0.5,0.2,0.5,0.5S30,3.9,29.7,3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7,26.9H0.9c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h28.8c0.3,0,0.5,0.2,0.5,0.5C30.2,26.6,30,26.9,29.7,26.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoft2Lengeh1);
export default __webpack_public_path__ + "static/media/joft_2_lengeh_1.297731b1a83456a732143109334eccdd.svg";
export { ForwardRef as ReactComponent };